
import { defineComponent, onMounted } from 'vue';
import { AppFormRow, AppInput, AppCard, AppButton, AppSelect, AppDateTimePicker, AppFileUpload } from '@/components';
import { usePromotionPlanAdd } from '@/modules/promotion/plan/model/add';
import { Options } from '@/modules/promotion/plan/model/mixins';
import { ROUTE_NAME_PROMOTION } from '@/modules/promotion/router';

export default defineComponent({
    name: ROUTE_NAME_PROMOTION.PLAN.ADD,
    components: { AppFormRow, AppInput, AppCard, AppButton, AppSelect, AppDateTimePicker, AppFileUpload },
    setup() {
        const { model, v$, beforeFetch, linkableItemOption, timeUnits, actions } = usePromotionPlanAdd();

        onMounted(async () => {
            await beforeFetch();
        });

        return { v$, model, actions, linkableItemOption, Options, timeUnits };
    }
});
